import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useGetAccountInfoQuery, useUpdateInfoMutation, useUpdatePasswordMutation } from "../../../../api/account";
import { Storage } from "../../../../modules/Storage";
import { useAppDispatch } from "../../../../store";
import { setAlertModal, setLoadingModal } from "../../../../store/slice/modal";
const Contents = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [accountKey] = useState(Storage.get("accountKey"));
  const [accountId] = useState(Storage.get("accountId"));
  const [isLogin] = useState(accountKey ? true : false);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const { data: accountInfo, isLoading, refetch } = useGetAccountInfoQuery(accountId);
  const [updateInfoAPI] = useUpdateInfoMutation();
  const [updatePasswordAPI] = useUpdatePasswordMutation();
  const role = Storage.get("role") === "client" ? "client" : "attorney";


  const { register, handleSubmit, getValues, setValue, setError, formState: { errors } } = useForm();

  useEffect(() => {
    if (!isLogin) {
      dispatch(
        setAlertModal({
          modalState: true,
          modalData: { title: "Required Login", message: "You need to be logged in to access this page." },
          callback: () => {
            navigate("/en/login");
          }
        })
      );
    } else {
      //setUsername(Storage.get("humanName"));
      //setEmail(Storage.get("accountKey"));
      // if(accountInfo) console.log(accountInfo.data);
      if(accountInfo?.data?.humanName)  {
        // console.log(accountInfo.data);
        setUsername(accountInfo.data.humanName);
        setValue("humanName", accountInfo.data.humanName);
      }
      if(accountInfo?.data?.accountKey) {
        setEmail(accountInfo.data.accountKey);
        setValue("accountKey", accountInfo.data.accountKey);
      }
      if(accountInfo?.data?.phone) {
        setPhone(accountInfo.data.phone);
        setValue("phone", accountInfo.data.phone);
      }

    }
  }, [accountInfo]);

  const onSubmit = (data) => {
    // console.log("submit data : ", data);
    updateInfo(data);
  };

  const updateInfo = (accountInfo) => {
    dispatch(
      setLoadingModal({
        modalState: true,
      })
    );
    updateInfoAPI({ accountId: accountId, accountKey: accountInfo.accountKey, phone: accountInfo.phone})
      .unwrap()
      .then(({ status, data }) => {
        if (status === "success") {
          dispatch(
            setAlertModal({
              modalState: true,
              modalData: { title: "Edit Profile", message: "You have successfully updated your profile." },
              callback: () => {
                window.location.href = "/en/mypage";
              },
            })
          );
        } else {
          dispatch(
            setAlertModal({
              modalState: true,
              modalData: { title: "Edit Profile", message: "You have failed to update your profile." },
            })
          );
        }
      })
      .then((err) => {
        if (err) console.log(`error:${err}`);
      }).finally(() => {
        dispatch(
          setLoadingModal({
            modalState: false,
          })
        );
      });
  };


  const onPasswordSubmit = (data) => {
    // console.log("password submit data : ", data);
    updatePassword(data);
  };

  const updatePassword = (passwordInfo) => {
    // console.log("passwordInfo : accountId : ", accountId);
    // console.log("passwordInfo currentpassword : ", passwordInfo.password);
    // console.log("passwordInfo newpassword : ", passwordInfo.newPassword);
    if(!passwordInfo.password) {
      setError(
        "password",
        {
          message: "Enter your current password.",
        },
        { shouldFocus: true }
      );
      return;
    }
    if(!passwordInfo.newPassword) {
      setError(
        "newPassword",
        {
          message: "Enter your new password.",
        },
        { shouldFocus: true }
      );
      return;
    }
    if(passwordInfo.password === passwordInfo.newPassword) {
      setError(
        "newPassword",
        {
          message: "Current password and new password cannot be the same.",
        },
        { shouldFocus: true }
      );
      return;
    }
    if(getValues("newPassword") !== getValues("passwordConfirm")) {
      setError(
        "passwordConfirm",
        {
          message: "Passwords do not match.",
        },
        { shouldFocus: true }
      );
      return;
    }
    dispatch(
      setLoadingModal({
        modalState: true,
      })
    );
    updatePasswordAPI({ accountKey: passwordInfo.accountKey, password: passwordInfo.password, newPassword: passwordInfo.newPassword})
      .unwrap()
      .then(({ status, data }) => {
        if (status === "success") {
          dispatch(
            setAlertModal({
              modalState: true,
              modalData: { title: "Change Password", message: "You have successfully changed your password." },
              callback: () => {
                window.location.href = "/en/mypage";
              },
            })
          );
        } else {
          dispatch(
            setAlertModal({
              modalState: true,
              modalData: { title: "Change Password", message: "You have failed to change your password." },
            })
          );
        }
      }).finally(() => {
        dispatch(
          setLoadingModal({
            modalState: false,
          })
        );
      })
  };

  return (
    <main style={{ minHeight: "800px", background: "#e5ecef" }}>
      <section>
        <Container className="container">
          <div className="row">
            {/* left navigator START */}
            <div className="col-lg-3 col-12">
              <UserInfo className="d-none d-lg-block">
                <p className="user_name">{username}</p>
                <p className="user_email">{email}</p>
              </UserInfo>

              <MyPageMenu className="d-none d-lg-block">
                <p className="title">Edit Profile</p>
                <ul>
                  <li>
                    <Link to={"/en/mypage"}>
                      Matching Information
                    </Link>
                  </li>
                  <li>
                    <Link to={"/en/mypage/modify"} className="active">Edit Profile</Link>
                  </li>
                  {role === "attorney" && (
                    <li>
                      <Link to={"/en/mypage/resumeModify"}>Edit Attorney Profile</Link>
                    </li>
                  )}
                  <li onClick={() => Storage.logout()}>
                    <Link>Logout</Link>
                  </li>
                </ul>
              </MyPageMenu>
            </div>
            {/* left navigator END */}

            {/* right contents START */}
            <div className="col-lg-9 col-12">
              <div className="row">
                <div className="col-12">
                  <h2>Edit Profile</h2>
                  <hr />
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                      <div className="col-lg-6 col-12">
                        <div className="mb-3">
                          <label htmlFor="username" className="form-label">Name</label>
                          <input type="text" className="form-control" id="username" placeholder="Enter your name." defaultValue={username} disabled={true}
                          />
                          {errors?.humanName && <WarningMessage>{errors.humanName.message}</WarningMessage>}
                        </div>
                      </div>
                      {role === "attorney" && (
                      <div className="col-lg-6 col-12">
                        <div className="mb-3">
                          <label className="form-label">Referral Code (Click the code to copy the referral link)</label>
                          {accountInfo?.data?.personalCode ? (<p onClick={()=>{
                            navigator.clipboard.writeText("https://indip.kr/join?code="+accountInfo.data.personalCode);
                            alert("The referral link has been copied to the clipboard.");
                          }}>{accountInfo.data.personalCode}</p>) : (<p>No referral code available. Please contact the administrator.</p>)}
                        </div>
                      </div>)}
                      <div className="col-lg-6 col-12">
                        <div className="mb-3">
                          <label htmlFor="email" className="form-label">Email</label>
                          <input type="email" className="form-control" id="email" placeholder="Enter your email." defaultValue={accountKey}
                          {
                            ...register(
                              "accountKey", {
                                required: "Please enter your email.",
                                pattern: {
                                  value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                                  message: "Please enter a valid email address.",
                                },
                              }
                            )
                          }
                          />
                          {errors?.accountKey && <WarningMessage>{errors.accountKey.message}</WarningMessage>}
                        </div>
                      </div>
                      <div className="col-lg-6 col-12" />
                      <div className="col-lg-6 col-12">
                        <div className="mb-3">
                          <label htmlFor="phone" className="form-label">Phone Number</label>
                          <input type="tel" className="form-control" id="phone" placeholder="Enter your phone number." defaultValue={phone}
                          {
                            ...register(
                              "phone", {
                                required: "Please enter your phone number.",
                                pattern: {
                                  value: /^\d{10,11}$/,
                                  message: "Please enter a valid phone number.",
                                },
                              }
                            )
                          }
                          />
                          {errors?.phone && <WarningMessage>{errors.phone.message}</WarningMessage>}
                        </div>
                      </div>
                      <div className="col-lg-6 col-12" />
                      <div className="col-lg-6 col-12">
                        <div className="mb-3">
                          <button type="submit" className="btn btn-primary">Update Profile Information</button>
                        </div>
                      </div>
                      <div className="col-lg-6 col-12" />
                    </div>
                  </form>
                  <form onSubmit={handleSubmit(onPasswordSubmit)}>
                    <div className="row">
                      <div className="col-lg-6 col-12">
                        <div className="mb-3">
                          <label htmlFor="password" className="form-label">Current Password</label>
                          <input type="password" className="form-control" id="password" placeholder="Enter your password."
                          {
                            ...register("password", {
                              pattern: {
                                value: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&+-^])[A-Za-z\d@$!%*#?&+-^]{8,}$/,
                                message: "Password must be at least 8 characters long and include letters, numbers, and special characters.",
                              },
                            })
                          }
                          />
                          {errors?.password && <WarningMessage>{errors.password.message}</WarningMessage>}
                        </div>
                      </div>
                      <div className="col-lg-6 col-12" />
                      <div className="col-lg-6 col-12">
                        <div className="mb-3">
                          <label htmlFor="newPassword" className="form-label">New Password</label>
                          <input type="password" className="form-control" id="newPassword" placeholder="Enter your new password."
                          {
                            ...register("newPassword", {
                              pattern: {
                                value: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&+-^])[A-Za-z\d@$!%*#?&+-^]{8,}$/,
                                message: "Password must be at least 8 characters long and include letters, numbers, and special characters.",
                              },
                            })
                          }
                          />
                          {errors?.newPassword && <WarningMessage>{errors.newPassword.message}</WarningMessage>}
                        </div>
                      </div>
                      <div className="col-lg-6 col-12">
                        <div className="mb-3">
                          <label htmlFor="passwordConfirm" className="form-label">Confirm Password</label>
                          <input type="password" className="form-control" id="passwordConfirm" placeholder="Re-enter your new password."
                          {
                            ...register("passwordConfirm")
                          }
                          />
                          {errors?.passwordConfirm && <WarningMessage>{errors.passwordConfirm.message}</WarningMessage>}
                        </div>
                      </div>
                      <div className="col-lg-6 col-12">
                        <div className="mb-3">
                          <button type="submit" className="btn btn-danger">Update Password</button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          {/* right contents END */}
        </Container>
      </section>
    </main>
  );
}

const Container = styled.div`
  padding: 40px 0;

  @media (max-width: 991px) {
    padding: 40px 0;
  }
`;

const UserInfo = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fafbfe;
  padding: 20px;

  p.user_name {
    color: #070143;
    font-size: 25px;
    font-weight: 700;
    line-height: 1.2;
    padding: 3.4px 10px;
  }
  p.user_email {
    color: #687693;
    font-size: 15px;
    padding: 10px;
  }
`;

const MyPageMenu = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  background-color: transparent;
  margin-top: 65px;

  p.title {
    color: #070143;
    font-size: 23px;
    padding-bottom: 10px;
    position: relative;
    margin-bottom: 30px;
    width: 100%;

    &::before {
      position: absolute;
      width: 55px;
      height: 4px;
      left: 0;
      bottom: 0;
      background-color: #202d90;
      border-radius: 10px;
      content: "";
    }

    &::after {
      position: absolute;
      width: calc(80% - calc(var(--bs-gutter-x) * 0.5));
      height: 4px;
      left: 65px;
      bottom: 0;
      background-color: #f2f2f2;
      border-radius: 10px;
      content: "";
    }
  }

  ul {
    li {
      font-size: 19px;
      position: relative;

      & + li {
        margin-top: 12px;
      }

      a {
        color: #687693;
        display: block;
        width: 100%;
        transition: color 0.3s ease-in-out;

        &:hover {
          color: #1b267b;
        }

        &.active {
          color: #1b267b;
        }
      }
    }
  }
`;

const WarningMessage = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: #ff0000;
  letter-spacing: 0px;
  line-height: 20px;
  display: block;
  margin-top: 7px;
`;

export default Contents;